<button [ngClass]="css" type="button" (click)="openHelperPopup()" attr.aria-label="{{'GLOBAL.HELP' | translate }}: {{title | translate}}">
    <div *ngIf="stype.toLowerCase() == 'header'" class="font-icon-background"></div>
    <span [ngClass]="icss" class="fas fa-question-circle" style="pointer-events: none"></span>
</button>
